import { brandCss, DEFAULT_BRAND, deriveBrand } from "./brand.js";

export * from "./brand.js";

// In the browser (design v0.9): the firm's brand tokens on :root, and each
// person's look settings (Light, Dark or Match system; plain backgrounds),
// remembered in this browser.

export type ThemeChoice = "light" | "dark" | "system";
export type LookSettings = { theme: ThemeChoice; plain: boolean; railCollapsed: boolean };

const KEY = "staffsmith.look";
const DEFAULTS: LookSettings = { theme: "system", plain: false, railCollapsed: false };

export function readLook(): LookSettings {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...(JSON.parse(raw) as Partial<LookSettings>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export function applyLook(look: LookSettings) {
  const root = document.documentElement;
  if (look.theme === "system") delete root.dataset.theme;
  else root.dataset.theme = look.theme;
  if (look.plain) root.dataset.plain = "true";
  else delete root.dataset.plain;
}

export function saveLook(change: Partial<LookSettings>): LookSettings {
  const next = { ...readLook(), ...change };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* a private window: it holds for this page only */
  }
  applyLook(next);
  return next;
}

// The firm's colors as tokens, or StaffSmith's (the operator console always
// passes nothing).
export function applyBrand(
  brand?: { primary_color?: string | null; accent_color?: string | null } | null,
) {
  const tokens = deriveBrand(
    brand?.primary_color ?? DEFAULT_BRAND.primary,
    brand?.accent_color ?? DEFAULT_BRAND.accent,
  );
  let el = document.getElementById("brand-tokens");
  if (!el) {
    el = document.createElement("style");
    el.id = "brand-tokens";
    document.head.appendChild(el);
  }
  el.textContent = brandCss(tokens);
  return tokens;
}
